import { useQuery } from "react-query";
import { getEmployeeReportsTo } from "../../../../../actions/Utilities/EmployeeReportsTo";

export const useGetReportsTo = () => {
  return useQuery("getEmployeeReportsTo", getEmployeeReportsTo, {
    refetchOnWindowFocus: false,
  });
};
